import { render } from "./hr-multiple-choice-questions.vue?vue&type=template&id=2a81fe1a&scoped=true"
import script from "./hr-multiple-choice-questions.vue?vue&type=script&lang=js"
export * from "./hr-multiple-choice-questions.vue?vue&type=script&lang=js"

import "./hr-multiple-choice-questions.vue?vue&type=style&index=0&id=2a81fe1a&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604021339/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a81fe1a"]])

export default __exports__